import React from 'react';
import ThemeSelect from '../themeSelect/themeSelect';
import {
  ADMIN_STATUS_OPTIONS,
  APPOINTMENT_STATUS,
} from '../../constants/constants';

// Background class matching the appointment status, driven by the
// hand-written rules in src/index.css
const statusClassName = status => {
  switch (status) {
    case APPOINTMENT_STATUS.CHECKED_IN:
      return 'bg-blue';
    case APPOINTMENT_STATUS.ACCEPTED:
    case APPOINTMENT_STATUS.CHECKED_OUT:
      return 'bg-green';
    case APPOINTMENT_STATUS.REJECTED:
    case APPOINTMENT_STATUS.CANCELLED:
      return 'bg-red';
    case APPOINTMENT_STATUS.PENDING:
      return 'bg-yellow';
    default:
      return 'bg-transparent';
  }
};

const AppointmentStatusSelect = ({
  status,
  onChange,
  disabled,
  loading,
  className = 'w-32',
  ...props
}) => {
  // Filter out current status from options
  const availableOptions = ADMIN_STATUS_OPTIONS.filter(
    opt => opt.value !== status
  );

  // Format current status for display
  const displayStatus =
    ADMIN_STATUS_OPTIONS.find(opt => opt.value === status)?.label || 'Pending';

  return (
    <ThemeSelect
      {...props}
      value={displayStatus}
      options={availableOptions}
      className={`${className} ${statusClassName(status)}`}
      disabled={disabled}
      loading={loading}
      onChange={onChange}
    />
  );
};

export default AppointmentStatusSelect;
